import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `MovimientoVerraco/deleteSeleccionMovimientoVerraco`, method: 'POST', body: {list}, token: token})
}
